import { ContentProps } from 'types/content';

const PostType500: React.FC<ContentProps> = ({ type, data, meta, descendants }) => {
  return (
    <div className="max-w-content mx-auto text-center py-20">
      <h1>500 Internal Server Error</h1>
    </div>
  );
};

export default PostType500;
